import React, { Dispatch, FC, SetStateAction, useEffect } from 'react';
import { Col, FormGroup, Input, InputGroup, InputGroupText, Label } from 'reactstrap';
import { OptionInternal } from '../../../shared/options';
import { useTranslation } from '../../translations';
import { useConfig, useNullishNumericInputState, useNumericInputState } from '../../utils';

interface OptionEditorMinMaxProps {
  readonly label: 'Length' | 'Value';
  readonly option: OptionInternal;
  readonly setOption: Dispatch<SetStateAction<OptionInternal>>;
}

export const OptionEditorMinMax: FC<OptionEditorMinMaxProps> = ({ option, label, setOption }) => {
  const { ts } = useTranslation();
  const { currencySymbol } = useConfig();
  const isCurrency = option.type === 'currency';
  const [min, setMin] = useNumericInputState(isCurrency ? option.min / 100 : option.min);
  const [max, setMax] = useNullishNumericInputState(
    option.id === 0 ? 40_000 : isCurrency && option.max ? option.max / 100 : option.max,
  );

  useEffect(() => {
    setOption((old) => ({ ...old, max, min }));
  }, [setOption, max, min]);

  return (
    <>
      <Col lg={6} xs={12}>
        <FormGroup>
          <Label for="options">
            {ts('min')}
            {label}
          </Label>
          <InputGroup>
            {isCurrency && <InputGroupText>{currencySymbol}</InputGroupText>}
            <Input defaultValue={min} name="min" onChange={setMin} type="number" />
          </InputGroup>
        </FormGroup>
      </Col>
      <Col lg={6} xs={12}>
        <FormGroup>
          <Label for="options">
            {ts('max')}
            {label} <small>({ts('common.optional')})</small>
          </Label>
          {/* TODO: Null max? */}
          <InputGroup>
            {option.type === 'currency' && <InputGroupText>{currencySymbol}</InputGroupText>}
            <Input defaultValue={max ?? ''} name="max" onChange={setMax} type="number" />
          </InputGroup>
        </FormGroup>
      </Col>
    </>
  );
};
